import { addGraph, getGraph } from "./api";
import events from "./trackingEvents";

export function save(data) {
    if (data === null || data === undefined || data.nodes.length === 0) {
        return;
    }

    var nodes = data.nodes;
    const rootNode = nodes.find(n => n.group === 0);
    const nodeName = rootNode.name;
    
    nodes.forEach(n => {
        if (n.def) {
            delete n.def;
        }
    });
    addGraph(nodeName, nodes)
}


export function loadGraph(graphName, data, setData, setOnReload, setCurrentSelectedNode, onLoaded) {
    if (data!= null && data.nodes.length > 0) {
        save();
    }

    getGraph(graphName)
        .then(d => {
            var rootNode = d.nodes.find(n => n.group === 0);
            setData(d);
            setOnReload(true);
            setCurrentSelectedNode(rootNode.id);
            onLoaded();
            events.loadGraphEvent(graphName);
        })
        .catch(error => console.error("Error loading graph:", error));
}
